import refresh from './images/refresh.svg';
import cloud from './images/cloud.svg';
import logout from './images/logout.svg';
import styled from 'styled-components';

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: stretch;
`;

function GlobalStackButtons(props) {
  return <Buttons>
    <button type="button" className="btn btn-primary w-100" data-cy="refresh-btn" onClick={props.refresh}>
      <img src={refresh} alt={"refresh"} />
    </button>
    <button type="button" className="btn btn-primary w-100" disabled={!props.changed} data-cy="save-data-btn" onClick={props.upload}>
      <img src={cloud} alt={"upload"} />
    </button>
    <button type="button" className="btn btn-warning w-100" data-cy="logout-btn" onClick={props.logout}>
      <img src={logout} width="16px" height="16px" alt={"logout"} />
    </button>
    <p className="w-100" data-cy="timespent">time spent:<br /> {props.timespent}h</p>
  </Buttons>;
}

export { GlobalStackButtons };
